import React from "react";
import ReactDOM from "react-dom/client"; // 🔹 React 18에서는 이렇게 import해야 함
import App from "./App";
import "./index.css"; 

const root = ReactDOM.createRoot(document.getElementById("root")); // 🔹 React 18 방식
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
